import { render, staticRenderFns } from "./FormInputItem.vue?vue&type=template&id=1da4d016&"
import script from "./FormInputItem.vue?vue&type=script&lang=js&"
export * from "./FormInputItem.vue?vue&type=script&lang=js&"
import style0 from "./FormInputItem.vue?vue&type=style&index=0&id=1da4d016&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports